<template><div><h1 id="adressimport-verarbeiten" tabindex="-1"><a class="header-anchor" href="#adressimport-verarbeiten"><span>Adressimport verarbeiten...</span></a></h1>
<p>Adressimport verarbeiten... — Importiert Personendaten und Adressen in die eigene Datenbank, oder Fremddatenbank</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Der Job importiert Personendaten und Adressen. Dabei werden Übersetzungen von externen Codes in eigene Codes gemacht, es finden Abgleiche mit den bereits existierenden Adressen statt.</p>
<p>Für den Start eines Imports muss eine Adressimportdefinition inkl. Positionen erfasst werden. Siehe <RouteLink to="/referenz/refs/ft.refdata.adrimp.html" title="Adressimport in eigene Datenbank / Fremddatenbank">Adressimport in eigene Datenbank / Fremddatenbank</RouteLink> und <RouteLink to="/referenz/refs/ft.refdata.adrimppos.html" title="Adressimport in Datenbank (Positionen)">Adressimport in Datenbank (Positionen)</RouteLink>.</p>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Der Job verfügt über einen Testlauf. Die importierten Adressen können im Protokoll eingesehen werden, ohne dass sie tatsächlich importiert werden.</p>
</div>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Datenaustausch → Adressimport in eigene Datenbank → Adressimport verarbeiten...</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Importdefinition</dt>
<dd>Die sichtbare Definition wird verwendet (siehe <a class="link" href="ft.refdata.adrimp.html" title="Adressimport in eigene Datenbank / Fremddatenbank">Adressübenahme in eigene Datenbank</a>).</dd>
<dt>Ausgabe</dt>
<dd>Es wird ein Protokoll erstellt, welcher direkt im Einlesejob eingesehen werden kann.</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p><strong>Tabelle 68. mögliche Fehlercodes</strong></p>
<table>
<thead>
<tr>
<th>Code</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>ADRTYP</td>
<td>Adresstyp ist nicht &quot;p&quot; (Privat) oder &quot;f&quot; (Firma)</td>
</tr>
<tr>
<td>BRCD</td>
<td>ungültiger Berufs-/Branchencode</td>
</tr>
<tr>
<td>FIRMA</td>
<td>es handelt sich um Firma und Firmen sollen nicht eingelesen werden</td>
</tr>
<tr>
<td>HNUL</td>
<td>Adresse ohne Hausnummer</td>
</tr>
<tr>
<td>NAM</td>
<td>In dem Name (adr.name1) befindet sich das Zeichen &quot;.&quot;</td>
</tr>
<tr>
<td>NAMELEER</td>
<td>Der Name ist leer (adr.name1) - nur für Privatadressen</td>
</tr>
<tr>
<td>NoAdrnum</td>
<td>Adresse mit der eingelesenen Personen-ID wurde nicht gefunden.</td>
</tr>
<tr>
<td>PLZZ</td>
<td>ungültiger PLZZ (nur für Schweiz)</td>
</tr>
<tr>
<td>PSTRNR</td>
<td>Die Kombination Ort/PLZ-Strasse-Hausnummer ist ungültig</td>
</tr>
<tr>
<td>SEX</td>
<td>ungültiger Anredecode</td>
</tr>
<tr>
<td>SPCD</td>
<td>ungültiger Sprachcode</td>
</tr>
<tr>
<td>STR</td>
<td>Die Kombination PLZ-Postfach ist ungültig</td>
</tr>
<tr>
<td>STRNRFORM</td>
<td>Die Hausnummer ist grösser als 9999</td>
</tr>
<tr>
<td>VNAM</td>
<td>Der Vorname enthielt &quot;.&quot; oder &quot; &quot; oder begint mit &quot;Dr.&quot; oder &quot;Prof&quot; ode der Name (adr.name1) beginnt mit &quot;Dr.&quot;</td>
</tr>
<tr>
<td>ZNAM</td>
<td>Eine Privatadresse hat einen ausgefülltem Adresszusatz.</td>
</tr>
</tbody>
</table>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>Die Daten werden gelesen und entsprechend den Optionen in der Definition umgewandelt.</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>Grundsätzlich wird jede gelesene Adresse in funtrade erfasst, es sei denn es handelt sich um eine bereits existierende Adresse oder die Adresse wurde auf Grund der Abgleichsoptionen nicht akzeptiert (z.B. Organisation oder inkorrekte Postadresse).</p>
<p>Für eine importierte Adresse werden die Daten gemäss der Feldcodierung übersetzt und übernommen. Folgende Spezialfälle existieren:</p>
<ul>
<li>
<p>Ist in der Quelle kein Adresstyp vorhanden, ermittelt funtrade automatisch die Firma / Organisation auf Grund des Feldes &quot;Organisation&quot;, oder analysiert Feld &quot;Name/Organisation&quot; auf bestimmte Zeichenfolgen (AG, GmbH, etc.)</p>
</li>
<li>
<p>Ist in der Quelle kein Sprachcode vorhanden, ermittelt funtrade automatisch einen Sprachcode aus der Postleitzahl.</p>
</li>
<li>
<p>Wurde kein Anrede-Code geliefert, kann funtrade aufgrund der Vornamen einen Geschlechtscode indetifizieren.</p>
</li>
</ul>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.adrimp.html" title="Adressimport in eigene Datenbank / Fremddatenbank">Adressimport in eigene / Fremd-Datenbank</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.adrimppos.html" title="Adressimport in Datenbank (Positionen)">Adressimport in Datenbank (Positionen)</RouteLink></p>
</div></template>


